import styled, { css } from 'styled-components';

import { AccordionBanner } from 'src/payments/components/accordion-banner/accordion-banner';
import { Button } from 'src/components/core';
import { Typography } from 'src/typography';

// Counters the theme-wide MuiAccordion maxWidth:390 override (shared/components/accordion.jsx).
export const accordionFullWidthReset = css`
  max-width: unset;
`;

// Counters MUI's expanded margin:16px 0 where the parent stacks siblings with gap.
export const accordionExpandedMarginReset = css`
  &.MuiAccordion-root.Mui-expanded {
    margin: 0;
  }
`;

export const StepsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const Step = styled.li`
  align-items: center;
  color: var(--dcm-pbb-incentive-step-icon-color, ${({ theme }) => theme.colors.green90});
  display: flex;
  flex: 1;
  flex-direction: row;
  gap: 8px;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    align-items: flex-start;
    align-self: flex-start;
    flex-direction: column;
  }
`;

export const StepContent = styled(Typography.Label).attrs({ size: 'small' })`
  color: var(--dcm-pbb-incentive-step-text-color, ${({ theme }) => theme.colors.black});
`;

export const PdpIncentiveAccordionBanner = styled(AccordionBanner)`
  &.MuiPaper-root {
    height: unset;
    ${accordionFullWidthReset}
    min-height: unset;
    border: 1px solid var(--dcm-pdp-incentive-border-color, ${({ theme }) => theme.colors.green20});
    background-color: var(--dcm-pdp-incentive-background-color, #f4f8f7);
  }

  & > .MuiAccordionSummary-root,
  .MuiAccordionSummary-root.Mui-expanded {
    height: unset;
    min-height: unset;

    & > .MuiAccordionSummary-content {
      margin: 0;
    }
  }

  & > .MuiCollapse-container {
    border-top: 1px solid var(--dcm-pdp-incentive-border-color, ${({ theme }) => theme.colors.green20});
  }
`;

export const HeadlineRow = styled.span`
  align-items: center;
  display: flex;
  gap: ${({ theme }) => theme.spaces[3]};
  justify-content: space-between;
  width: 100%;
`;

export const BankLogoStripPlaceholder = styled.div`
  width: 100%;
  height: 100%;
`;

export const HeadlineText = styled.span`
  color: var(--dcm-pdp-incentive-text-color, ${({ theme }) => theme.colors.black});

  u {
    text-decoration-color: var(--dcm-pdp-incentive-accent, ${({ theme }) => theme.colors.green90});
  }
`;

export const LinkBankButton = styled(Button)`
  background-color: var(--dcm-pdp-incentive-cta-background, #006149);
  border-radius: var(--dcm-pdp-incentive-cta-radius, 6px);
  font-weight: 600;
  padding: 4px 6px;
  text-transform: var(--dcm-pdp-incentive-cta-text-transform, none);
`;
